export default "__VITE_ASSET__DXRZ$E0U__"